import { isValidNumber } from "libphonenumber-js";

export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const PAPS_OPS_ADDRESS_SN = "PAPS (Entrepot), Rue DD 49, Dakar";
export const PAPS_OPS_ADDRESS_CI = "Résidence WALID, Avenue 17, Abidjan, Côte d'Ivoire";
export const PAPS_OPS_ADDRESS_BJ =
  "Aéroport International 'Cardinal Bernardin Gantin' de Cotonou, Rue 2100, Cotonou, Bénin";
export const PAPS_OPS_ADDRESS_GN = "Aeroport International Ahmed Sékou Touré, Gbessia, Guinée";
export const PAPS_OPS_ADDRESS_ML = "Aéroport international Modibo Keita, G3P4+V78, Bamako, Mali ,Bamako, Mali";
export const PAPS_OPS_ADDRESS_TG= "Aéroport International Gnassingbé Eyadéma (AIGE), Lomé, Togo ,Lomé, Togo";
export const CORS_EVERY_WHERE = "https://cors-anywhere.herokuapp.com/";
export const DATE_FORMAT = "YYYY-MM-DD";
export const PAPS_OBS_PLACE_ID = "ChIJifnSZo1zwQ4RRj8TbX6qIVA";
export const PAPS_AIRBILL_INFO = {
  SN: `Dakar (Sénégal), Cité Keur Guorgui, Imm Elysée 2
    +221 33 825 85 56 / +221 78 120 30 30
    hello@paps-app.com / www.papslogistics.com`,
  CI: `Rue J75, derrière l’école primaire ClaireFontaine,\n II Plateaux Vallon, Cocody – Abidjan.
    Numéro Téléphone Fixe : +225 2722246401
    Numéro Téléphone Mobile/WhatsApp : +225 0799503580
    hello@paps-app.com / www.papslogistics.com`,
  BJ: `Dakar (Sénégal), Cité Keur Guorgui, Imm Elysée 2
    +221 33 825 85 56 / +221 78 120 30 30
    hello@paps-app.com / www.papslogistics.com`,
  GN: `Dakar (Sénégal), Cité Keur Guorgui, Imm Elysée 2
    +221 33 825 85 56 / +221 78 120 30 30
    hello@paps-app.com / www.papslogistics.com`,
    ML: `Aéroport international Modibo Keita, G3P4+V78, Bamako, Mali, Bamako, Mali
    +223 300 00000 / +223 300 00000
    hello@paps-app.com / www.papslogistics.com` ,

  TG: `Aéroport International Gnassingbé Eyadéma (AIGE), Lomé, Togo, Lomé, Togo
    +228 300 00000 / +228 300 00000
    hello@paps-app.com / www.papslogistics.com`
};

export const DISTANCES = {
  D_50: 50000,
  D_100: 100000,
  D_300: 300000,
};

export const PHONE_NUMBERS_SEN = ["75", "76", "77", "78", "33", "70", "30"];
export const GOOGLE_CLIENT_ID = "792876308997-v719070vegi1cgl4b40a0u51u662hfbh.apps.googleusercontent.com";

export const DEV_TOKEN =
  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7InJlc2V0VG9rZW4iOnsidG9rZW4iOiI1YzhhMDZlMDc4OTVlNjE4YzU4ZGZkMWY1NGUyNjNkNWUwOTA0NWM3OTVhOWI4MWQ2MzAxOTZiYmNhNWQ2ODYzODA4ZGU2Y2Q1ZjY5MjNjMSIsImV4cGlyZXMiOiIyMDIwLTExLTA1VDEwOjM3OjE2LjQzMloifSwicm9sZXMiOltdLCJpc19kZWxldGVkIjpmYWxzZSwiX2lkIjoiNWY5NzBmYzc3YjczYzQwMDM4NmM3ZDg4IiwiZmlyc3RfbmFtZSI6IlBhcGEgT3VzbWFuZSIsImxhc3RfbmFtZSI6Ik5kaWF5ZSIsImVtYWlsIjoicG5kaWF5ZUBwYXBzLWFwcC5jb20iLCJwaG9uZV9udW1iZXIiOiIrMjIxNzc2MDY3MTcxIiwidmVyaWZpY2F0aW9uVG9rZW4iOm51bGwsImNyZWF0ZWRfYXQiOiIyMDIwLTEwLTI2VDE4OjA0OjU1LjM5MFoiLCJsYXN0X2VkaXRlZF9hdCI6IjIwMjAtMTAtMjZUMTg6MDQ6NTUuMzkwWiIsIl9fdiI6MCwidmVyaWZpZWQiOiIyMDIwLTEwLTI2VDE4OjA1OjE0LjMxMloiLCJwYXNzd29yZEhhc2giOiIkMmIkMTAkUFJUdFl0cy9KTERzSmVFRVllMWRGZVZRYWJDWjg5Vm5TcmxkRVluRUFYdnc5blRQcWxjMEciLCJwYXNzd29yZFJlc2V0IjoiMjAyMC0xMC0yNlQxODowNzo1Ny40MzdaIn0sImlhdCI6MTYwNjc1NzYzMCwiZXhwIjoxNjA3MzYyNDMwLCJpc3MiOiJhdXRoIn0.1OFthGRfW0Kia0VOYDRuQKmKNfDL3F3LZ9jz7gHl33o";

export const DRAWER_WIDTH = "45%";

export const isValidPhoneNumberFormat = (phoneNumber: string) => phoneNumber && isValidNumber(phoneNumber);
export const removeFormatNumber = (phoneNumber: string) => phoneNumber?.length && phoneNumber.replace(/(?!\+)\D/g, "");
export const SN_BIGIN_PHONE_NUMBER_REG = /^(00|\+)?221/g;
export const DATE_FORMAT_PRINT = "DD/MM/YYYY";

export const QueryCategoriesApi = `query allCategories($queries: CategoriesFetchQueries) {
    allCategories(queries: $queries) {
      statusCode
      message
      data {
        categories {
             _id
            code
            translations{
              lang
              text
            }
        }
      }
    }
  }`;
